var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"icjia"}},[_c('SidebarMenu'),_c('headroom',{attrs:{"disabled":!_vm.headroom}},[_c('header',[_c('v-toolbar',{attrs:{"clipped-left":_vm.clipped}},[_c('img',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({
            el: '#top',
            offset: -50
          }),expression:"{\n            el: '#top',\n            offset: -50\n          }"}],staticClass:"logo",attrs:{"src":require("../assets/img/logo-small.png"),"width":"80","alt":"Illinois Criminal Justice Information Authority"}}),_c('v-toolbar-title',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({
            el: '#top',
            offset: -50
          }),expression:"{\n            el: '#top',\n            offset: -50\n          }"}],staticClass:"appTitle",class:{
            xs: _vm.$vuetify.breakpoint.xs,
            sm: _vm.$vuetify.breakpoint.sm
          }},[(
              _vm.$vuetify.breakpoint.md ||
                _vm.$vuetify.breakpoint.lg ||
                _vm.$vuetify.breakpoint.xl
            )?_c('span',[_vm._v(_vm._s(_vm.config.meta.title))]):_c('span',[_vm._v(_vm._s(_vm.config.meta.title))])]),_c('v-spacer'),_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();return _vm.toggleSidebar($event)}}})],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }